import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppLayoutModule } from './app-layout/app-layout.module';
import { CommonsModule } from './commons/commons.module';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ScrollbarModule } from 'ngx-scrollbar';
import { MatTreeModule } from '@angular/material/tree';

import { AuthGuard } from './_guards/auth.guard';
import { CanDeactivateGuard } from './_guards/can-deactivate.guard';

import { HeaderInterceptor } from './_interceptors/header.interceptor';

import { AuthService, AuthContextService } from './_services/auth.service';
import { FormValidationMessageService } from './_services/form-validation-message.service';
import { UserService } from './_services/user.service';
import { VaService } from './_services/va.service';
import { LoadingSpinnerService } from './_services/loading-spinner.service';
import { SearchService } from './_services/search.service';
import { TrainingService } from './_services/training.service';
import { VaLauncherService } from './_services/va-launcher.service';
import { ScriptingService } from './_services/scripting.service';
import { CustomiseService } from './_services/customise.service';
import { FlowService } from './_services/flow.service';
import { IntegrationService } from './_services/integration.service';
import { CommunictionService } from './_services/communiction.service';

import { UserConfigResolve } from './_services/user-config-resolve.service';
import { VaListResolve } from './_services/va-list-resolve.service';


import { AppComponent } from './app.component';
import { ListVaComponent } from './list-va/list-va.component';
import { VirtualAssistantCardComponent } from './virtual-assistant-card/virtual-assistant-card.component';
import { ProjectComponent } from './project/project.component'; 


import { KbService } from './_services/kb.service';
import { ConfirmationDialogService } from './_services/confirmation-dialog.service';
import { OntologyTreeService } from './_services/ontology-tree.service';
import { ConfirmationDialogComponent } from './_directives/confirmation-dialog/confirmation-dialog.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgConfirmationDialogComponent } from './_directives/ng-confirmation-dialog/ng-confirmation-dialog.component';
import { NotificationComponent } from './_directives/notification/notification.component';
import { RestrictCutcopypasteDirective } from './_directives/restrict-cutcopypaste/restrict-cutcopypaste.directive';

import { LongProgressService } from './_services/long-progress.service';
import { NotificationAPIService, NotificationService } from './_services/notification.service';
import { SocketService } from './_services/socket.service';
import { IngetionService } from './_services/ingetion.service';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { TrashComponent } from './trash/trash.component';

import { CommunityService } from './_services/community.service';
import { PushNotificationsService } from './_services/push.notification.service';
import { PromotionService } from './_services/promotion.service';

import { StorageService } from './_services/storage.service';
import { KnowledgeRepositoryService } from './_services/knowledge-repository.service';
import { ProfileService } from './_services/profile-service';
import { ArticleLibraryService } from './_services/article-library.service';
import { TopicMappingService } from './_services/mapped-topic.service';
import { FormAssistanceService } from './_services/form-assistance.service';
import { RecommendationService } from './_services/recommendation.service';
import { AlertsService } from './_services/alerts.service';
import { KbRecommendationService } from './_services/kb-recommendation.service';
import { TourNgBootstrapModule} from 'ngx-tour-ng-bootstrap';
import { DraggablePopupComponent } from './_directives/draggable-popup/draggable-popup.component';
import { DraggableService } from './_services/draggable.service';
import { AngularDraggableModule } from 'angular2-draggable';
import { TourGuideService } from './_services/tour-guide.service';
import { DataTrackingService } from './_services/data-tracking.service';
import { DownloadService } from './_services/download.service';
import { InstructorGuardService } from './_guards/instructor.guard';
import { ContentSearchService } from './_services/content-search.service';
import { ReleaseHistoryComponent } from './release-history/release-history.component';
import { ReleaseService } from './_services/release.service';
import { LogoutGuard } from './_guards/logout.guard';
import { DatePipe } from '@angular/common';


@NgModule({
  declarations: [
    AppComponent,
    ListVaComponent,
    VirtualAssistantCardComponent,
    ConfirmationDialogComponent,
    NgConfirmationDialogComponent,
    
    UserProfileComponent,
    RestrictCutcopypasteDirective,
    TrashComponent,
    ProjectComponent,
    DraggablePopupComponent,
    ReleaseHistoryComponent
  ],
  exports:[],
  imports: [
    BrowserModule,
    CommonsModule,
    AppRoutingModule,
    FlexLayoutModule,
    BrowserAnimationsModule,
    AppLayoutModule,
    HttpClientModule,
    ScrollbarModule,
    ImageCropperModule,
    AngularDraggableModule,
    NgbModule,
    TourNgBootstrapModule.forRoot(),
    MatTreeModule
  ],
  providers: [
    PushNotificationsService,
    AuthGuard,
    LogoutGuard,
    AuthService,
    UserService,
    VaService,
    UserConfigResolve,
    VaListResolve,
    KbService,
    OntologyTreeService,
    AuthContextService,
    LoadingSpinnerService,
    FormValidationMessageService,
    SearchService,
    ContentSearchService,
    ConfirmationDialogService,
    LongProgressService,
    IngetionService,
    NotificationService,
    TrainingService,
    ProfileService,
    TopicMappingService,
    VaLauncherService,
    ScriptingService,
    CustomiseService,
    SocketService,
    CommunityService,
    FlowService,
    IntegrationService,
    CommunictionService,
    PromotionService,
    NotificationAPIService,
    KnowledgeRepositoryService,
    StorageService,
    FormAssistanceService,
    ArticleLibraryService,
    RecommendationService,
    KbRecommendationService,
    AlertsService,
    DraggableService,
    TourGuideService,
    CanDeactivateGuard,
    DownloadService,
    InstructorGuardService,
    DataTrackingService,
    DatePipe,
    ReleaseService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true
    }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  entryComponents: [ConfirmationDialogComponent, NgConfirmationDialogComponent, DraggablePopupComponent],
})
export class AppModule { }
